import React from 'react'
import { Badge, BadgeColor, Icon } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { TContact } from '../../../common/validations/contractContacts'
import { ContactCategory } from '../../../common/types'

import { RoundLink } from 'components'

type Props = {
  contacts?: TContact[]
  badgeColor?: BadgeColor
}

export const MaintenanceContacts: React.FC<Props> = ({
  contacts,
  badgeColor = BadgeColor.PRIMARY,
}) => {
  const { t } = useTranslation(['contact', 'common'])
  const propertyMaintenance = contacts?.find(
    (c) => c.contactCategory === ContactCategory.PROPERTY_MAINTENANCE
  )

  const renderContact = (
    label: string,
    contact: TContact,
    showContactName = true
  ) => (
    <div
      className="grid grid-cols-2 min-tablet:block mb-8"
      key={`${contact.email}-${contact.id}`}
    >
      <div>
        {contact.officeName && (
          <p className="mb-3 text-base min-tablet:text-xl font-medium">
            {contact.officeName}
          </p>
        )}
        {showContactName && <p>{contact.name}</p>}
        {contact.phoneNumber && (
          <p className="text-sm lg:text-base">
            <a
              href={`tel:${contact.phoneNumber}`}
              aria-label={`${t('contact:call')} ${contact.name ? ` ${contact.name}` : ''} ${contact.phoneNumber}`}
            >
              {contact.phoneNumber}
            </a>
          </p>
        )}
        <p className="text-sm lg:text-base">
          <a
            href={`mailto:${contact.email}`}
            aria-label={`${t('contact:email')} ${contact.name ? ` ${contact.name}` : ''} ${contact.email}`}
          >
            {contact.email}
          </a>
        </p>
        <Badge className="mt-2" color={badgeColor}>
          {label}
        </Badge>
      </div>
      <div className="flex justify-end min-tablet:hidden">
        {contact.phoneNumber && (
          <RoundLink
            className="flex items-center mr-3 bg-primary text-white"
            href={`tel:${contact.phoneNumber}`}
          >
            <Icon icon="phone" size="lg" className="w-6" />
          </RoundLink>
        )}
        <RoundLink
          className="flex items-center bg-primary text-white"
          href={`mailto:${contact.email}`}
        >
          <Icon icon="email" size="lg" className="w-6" />
        </RoundLink>
      </div>
    </div>
  )

  if (!propertyMaintenance?.phoneNumber) {
    return null
  }

  return renderContact(t('contact:propertyMaintenance'), propertyMaintenance)
}
